import axios from 'axios';

export const getSiteAvailability = async () => {
  const { data } = await axios.get('/api/site-availability');
  return data;
};

export const updateSiteAvailability = async (payload) => {
  const { data } = await axios.patch('/api/site-availability', payload);
  return data;
};
